import {Model} from "vue-mc";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class profileModel extends Model {

    options() {
        return {
            methods: {}
        }
    }

    defaults() {
        return {
            interpreter_id: '',
            fm_interpreter_id: '',
            username: '',
            password: '',
            languages: '',
            address: '',
            email: '',
            first_name: '',
            surname: '',
            suburb: '',
            postcode: '',
            phone: '',
            mobile: '',
            web_access: '',
            wwcc: '',
            police_check: ''
        }
    }

    routes() {
        return {
            fetch: 'interpreter/profile'
        }
    }
}
